angular.module('internal.exams')
    .directive('internalExamsHeader', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'exams/components/exam-session-header/exam-session-header.html',
            controller: 'InternalInvestigationHeader',
            replace: true
        };
    }])
    .controller('internalExamsHeader', ['$scope', 'Permissions', function ($scope, Permissions) {
        $scope.getPermission = function (state, variable, method) {
            Permissions[method](state).then(function (access) {
                $scope[variable] = access;
            })
        }
    }])
;